export default {
    nbRowText: '{count} campagnes supervisées',
    status: [
        {
            value: 'inactive',
            text: 'Non commencée'

        },
        {
            value: 'open',
            text: 'En cours'
        },
        {
            value: 'closed',
            text: '✓ Terminée'
        }
    ]
};